export default function Icon() {
  return {}
}
